import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from "tss-react/mui";
import MediaQuery from 'react-responsive';
import styles from './styles';
import classNames from 'classnames';

const HeaderLink = props => (
    <MediaQuery maxDeviceWidth={767}>
        {(matches) =>
            <React.Fragment>
                {(!matches || (!Boolean(props.hideOnMobile))) &&
                    <li className={props.classes.headerLi}>
                        {props.href &&
                            <a className={classNames(props.classes.anchor, props.active ? props.classes.active : '')} href={props.href} target={props.target}>{props.text}</a>
                        }
                        {!props.href &&
                            <span>{props.text}</span>
                        }
                    </li>
                }
            </React.Fragment>
        }
    </MediaQuery>
);

HeaderLink.propTypes = {
    hideOnMobile: PropTypes.bool,
    text: PropTypes.string,
    href: PropTypes.string,
    active: PropTypes.bool,
    target: PropTypes.string
};

export default withStyles(HeaderLink, styles);